<app-dar-consultation [dossierId]="dossierId" [byModal]="byModal"></app-dar-consultation>
